/* src/app/shared/dialogs/release-dialog/release-dialog.component.scss */
:host {
  overflow: none;
}
.dialog-container {
  width: 530px;
  position: relative;
}
.dialog-container h1 {
  font-size: 18px;
  font-weight: bold;
  line-height: 0.83;
  text-align: left;
  margin: 0;
  margin-top: 8px;
  margin-bottom: 12px;
}
.dialog-container .button-cancel {
  position: absolute;
  right: 0;
  top: 0;
}
.dialog-container p {
  font-size: 16px;
  line-height: 1.19;
  letter-spacing: 0.1px;
  text-align: left;
  margin-top: 32px;
}
.dialog-container .info-text {
  font-size: 15px;
  font-weight: bold;
  text-align: left;
  color: #333333;
  margin-top: 24px;
}
.dialog-container .dialog-actions {
  margin-bottom: 0px;
  margin-top: 32px;
}
.dialog-container .dialog-actions button {
  margin-left: auto;
  margin-right: auto;
}
.dialog-container .dialog-actions button.primary {
  width: 160px;
  height: 50px;
  border-radius: 25px;
  background-color: #61566e;
  font-size: 14px;
  color: #f2eee7;
}
.dialog-container .dialog-actions button.primary:disabled {
  background-color: #61566e;
  color: #f2eee7;
  opacity: 0.5;
}
/*# sourceMappingURL=release-dialog.component.css.map */
